import { render, staticRenderFns } from "./CreateGateway.vue?vue&type=template&id=134ddcbc"
import script from "./CreateGateway.vue?vue&type=script&lang=js"
export * from "./CreateGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports